import React from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { Input as InputBS } from 'reactstrap';
const Input = (props) => {
    const {
        type,
        onChange = ()=> {},
        maxSize = Number.MAX_SAFE_INTEGER,
        ...restProps
    } = props;

    const { t } = useTranslation();

    const onHandleChange = (event) => {
        let files = event.target?.files?.[0];

        if (type === 'file' && files) {
            const sizeFile = files.size / (1080 * 1080);
            if (sizeFile > maxSize) {
                files = null;
                event.target.value = null;

                toast.error(t(`File is larger than ${maxSize * 1000000} bytes`));
                return;
            }
        }

        onChange(event);
    };

    return (
        <InputBS
            {...restProps}
            type={type}
            onChange={onHandleChange}
        />
    );
};

export default Input;
